import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.cognito.authority,
    redirectUrl: environment.cognito.redirectUrl,
    postLogoutRedirectUri: environment.cognito.redirectUrl,
    clientId: environment.cognito.clientId,
    scope: 'email openid',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
  },
};
